<template>
  <div class="error" >
    <img src="@assets/img/404@3x.png" style="width:200px;height: auto" alt="" />
    <h4 style="margin:12px 0 40px 0">
      很抱歉，没有找到您要访问的页面！
    </h4>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.page {
  overflow: hidden;
  width: 100%;
}
.error {
  width: 80%;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 100px;
  overflow: hidden;
  height: 800px;
  text-align: center
}
</style>
